<fieldset class="in-one-column">
  <legend>{{ TITLE + "ALLERGENIC" | translate }}:</legend>

  <mat-chip-listbox [multiple]="true">
    <mat-chip-option
      *ngFor="let item of allergenicFieldNamesAndTranslations | keyvalue"
      class="easy-chip multiple"
      [disabled]="group.disabled"
      (selectionChange)="selectionChange($event, item.key)"
      [selected]="group.controls[item.key].value"
      >{{ ALLERGENIC + item.value | translate }}</mat-chip-option
    >
  </mat-chip-listbox>
</fieldset>
